import { Configuration, RedirectRequest } from '@azure/msal-browser';
import { i18n } from 'i18n';

// Config.
import { env } from './env';

const getAuthExtraQueryParameters = (): Record<string, string> => {
  const extraQueryParameters: Record<string, string> = {
    ui_locales: i18n.language,
  };

  const params = new URLSearchParams(window.location.search);

  const optionKey = Array.from(params.keys()).find(
    (key) => key.toLowerCase() === 'option',
  );
  if (optionKey) {
    extraQueryParameters.option = params.get(optionKey)!;
  }

  const isLmsSignUpKey = Array.from(params.keys()).find(
    (key) => key.toLowerCase() === 'islmssignup',
  );
  if (isLmsSignUpKey) {
    extraQueryParameters.isLmsSignUp = params.get(isLmsSignUpKey)!;
  }

  const emailKey = Array.from(params.keys()).find(
    (key) => key.toLowerCase() === 'email',
  );
  if (emailKey) {
    extraQueryParameters.email = params.get(emailKey)!;
  }

  return extraQueryParameters;
};

export const msalConfig: Configuration = {
  auth: {
    authority: `https://${env.B2C_DOMAIN}/${env.B2C_TENANT}/${env.B2C_POLICY}`,
    clientId: env.B2C_CLIENT_ID,
    knownAuthorities: [env.B2C_DOMAIN],
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalRequest: RedirectRequest = {
  extraQueryParameters: getAuthExtraQueryParameters(),
  scopes: ['openid', env.B2C_CLIENT_ID],
};
